module.exports = __webpack_public_path__ + "img/lucho.adb24125.png";